import React from 'react'
import {graphql, useFragment} from 'react-relay'
import {Link} from 'react-router-dom'

import {useRunningBuildUpdaterRelay} from '../../../../../../hooks/relay/useRunningBuildUpdaterRelay'
import {useBuildStatusIconRelay} from '../../../../../../hooks/useBuildStatusIcon'
import Routes, {getHref} from '../../../../../../routes'
import JobIconStatus from '../../../components/common/JobIconStatus/JobIconStatus'
import {usePipelineId} from '../../../hooks/pipeline'

import type {PipelineLastRunJobFragment$key} from './__generated__/PipelineLastRunJobFragment.graphql'

import styles from './PipelineLastRunJob.css'

type Props = {
  x: number
  y: number
  jobKey: PipelineLastRunJobFragment$key | null
  runId: string
}

const fragment = graphql`
  fragment PipelineLastRunJobFragment on Build {
    rawId
    buildType {
      name
    }
    parallelized
    status
    ...useBuildStatusIconFragment
    ...useRunningBuildUpdaterRelayFragment
  }
`

export default function PipelineLastRunJob({x, y, jobKey, runId}: Props) {
  const id = usePipelineId()
  const job = useFragment(fragment, jobKey)
  const {rawId: jobId, buildType} = job ?? {}
  const icon = useBuildStatusIconRelay(job)

  useRunningBuildUpdaterRelay(job)

  return (
    <Link
      to={{pathname: getHref(Routes.PIPELINE_RUN, {id, runId}), search: `job=${jobId}`}}
      className={styles.tile}
      style={{top: x, left: y}}
    >
      <JobIconStatus
        parallelized={job?.parallelized}
        icon={icon}
        status={job?.status}
        className={styles.icon}
      />
      <div className={styles.name}>{buildType?.name}</div>
    </Link>
  )
}
